/* eslint-disable no-undef */
import { useCurrencyInput } from "vue-currency-input";
import { watch } from 'vue'
export default {
	name: "currency-input",
	props: {
		modelValue: Number,
		options: Object,
	},
	setup(props) {
		const { inputRef,setOptions, setValue } = useCurrencyInput(props.options);
		watch(
			() => props.modelValue, // Vue 2: props.value
			(value) => {
				setValue(value)
			}
		)

		watch(
			() => props.options,
			(options) => {
				setOptions(options)
			}
		)
		return { inputRef };
	},
};